'use strict'

import { Map as ImmutableMap, List as ImmutableList, fromJS } from 'immutable'
import {
  LIVE_STREAMS_FETCH_REQUEST,
  LIVE_STREAMS_FETCH_SUCCESS,
  LIVE_STREAMS_FETCH_FAIL,
  LIVE_STREAM_CREATE_SUCCESS,
  LIVE_STREAM_END_SUCCESS,
  LIVE_STREAM_SHOW_SUCCESS,
  LIVE_STREAM_BY_USERNAME_SUCCESS,
  LIVE_STREAM_SET_CURRENT,
  LIVE_STREAM_UPDATE_VIEWER_COUNT,
  LIVE_STREAM_CHAT_MESSAGE,
  LIVE_STREAM_HEART,
} from '../actions/live_streams'

const MAX_CHAT_MESSAGES = 100
const MAX_HEARTS = 20

const initialState = ImmutableMap({
  items: ImmutableList(),
  isLoading: false,
  isError: false,
  currentStreamId: null,
  chatMessages: ImmutableMap(),
  hearts: ImmutableMap(),
})

export default function liveStreams(state = initialState, action) {
  switch (action.type) {
    case LIVE_STREAMS_FETCH_REQUEST:
      return state.set('isLoading', true).set('isError', false)
    case LIVE_STREAMS_FETCH_SUCCESS: {
      const existingItems = state.get('items')
      const newItems = fromJS(action.streams).map(newStream => {
        const existing = existingItems.find(s => s.get('id') === newStream.get('id'))
        return existing ? existing.merge(newStream) : newStream
      })
      return state.set('items', newItems).set('isLoading', false)
    }
    case LIVE_STREAMS_FETCH_FAIL:
      return state.set('isLoading', false).set('isError', true)
    case LIVE_STREAM_CREATE_SUCCESS:
      return state.update('items', list => list.unshift(fromJS(action.stream)))
    case LIVE_STREAM_END_SUCCESS:
      return state.update('items', list =>
        list.filter(s => s.get('id') !== action.stream.id)
      )
    case LIVE_STREAM_SHOW_SUCCESS:
    case LIVE_STREAM_BY_USERNAME_SUCCESS:
      return state.update('items', list => {
        const idx = list.findIndex(s => s.get('id') === action.stream.id)
        if (idx >= 0) {
          return list.set(idx, fromJS(action.stream))
        }
        return list.push(fromJS(action.stream))
      })
    case LIVE_STREAM_SET_CURRENT:
      return state.set('currentStreamId', action.streamId)
    case LIVE_STREAM_UPDATE_VIEWER_COUNT:
      return state.update('items', list =>
        list.map(s =>
          s.get('stream_id') === action.streamId
            ? s.set('viewer_count', action.count)
            : s
        )
      )
    case LIVE_STREAM_CHAT_MESSAGE: {
      const key = action.streamId
      const messages = state.getIn(['chatMessages', key], ImmutableList())
      return state.setIn(
        ['chatMessages', key],
        messages.push(fromJS(action.message)).takeLast(MAX_CHAT_MESSAGES)
      )
    }
    case LIVE_STREAM_HEART: {
      const key = action.streamId
      const hearts = state.getIn(['hearts', key], ImmutableList())
      return state.setIn(
        ['hearts', key],
        hearts.push(fromJS(action.heart)).takeLast(MAX_HEARTS)
      )
    }
    default:
      return state
  }
}
